import is from 'is_js';
import pickBy from 'lodash/pickBy';
import has from 'lodash/has';

const getActiveFilters = searchFilterValues => pickBy(searchFilterValues, (item, key) => {
  const isEmpty = is.empty(item);
  const isNull = is.null(item);
  const isObj = is.object(item);

  if (key === 'type' || isNull || isEmpty) {
    return false;
  }

  if (isObj) {
    if (has(item, 'start') && has(item, 'end')) {
      if (is.not.null(item.start) || is.not.null(item.end)) {
        return true;
      }

      return false;
    }

    return true;
  }

  return true;
});

export default getActiveFilters;
